import { ObtenerSucursales, Cargando, Error } from "../Types/Sucursal.type";

const INITIAL_STATE = {
  Sucursales: [],
  Resultado: "",
  Mensaje: "",
  Cargando: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ObtenerSucursales:
      return {
        ...state,
        Sucursales: action.payload,
        Resultado: action.Resultado,
        Mensaje: action.Mensaje,
        Cargando: false,
      };
    case Cargando:
      return {
        ...state,
        Resultado: "",
        Mensaje: "",
        Cargando: true,
      };
    case Error:
      return {
        ...state,
        Resultado: "E",
        Mensaje: action.Mensaje,
        Cargando: false,
      };
    default:
      return state;
  }
};
